<nz-layout>
  <nz-content>
    <div class="authContainer align-middle"
      [ngStyle]="{ backgroundImage: 'url(' + assetsBase + '/images/pages/login/loginbg-01.jpg' }">
      <div class="containerInner">
        <div [@slideFadeinUp]="routeAnimation(outlet, 'slideFadeinUp')"
          [@slideFadeinRight]="routeAnimation(outlet, 'slideFadeinRight')"
          [@zoomFadein]="routeAnimation(outlet, 'zoomFadein')" [@fadein]="routeAnimation(outlet, 'fadein')">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
      <div>
        <ul class="footerNav list-unstyled d-flex mb-0 flex-wrap justify-content-center">
          <!-- <li class="list-inline-item">
            <a class="font-footer" href="javascript: void(0);">Términos de Uso</a>
          </li> -->
          <li class="list-inline-item">
            <a class="font-footer" href="https://redcoop.redcoopcentral.com:4443/usdkv8/#/login/?tokenBranding="
              target="_blank">Soporte</a>
          </li>
          <li class="list-inline-item">
            <a class="font-footer" href="https://www.redcoopcentral.com/canales-de-atencion/"
              target="_blank">Contactenos</a>
          </li>
          <li class="list-inline-item">
            <a class="font-footer" href="https://www.redcoopcentral.com/" target="_blank">Red Coopcentral</a>
          </li>
        </ul>
      </div>
    </div>
  </nz-content>
</nz-layout>
